import { render, staticRenderFns } from "./BalanceOutput.vue?vue&type=template&id=dccd434c&scoped=true"
import script from "./BalanceOutput.vue?vue&type=script&lang=js"
export * from "./BalanceOutput.vue?vue&type=script&lang=js"
import style0 from "./BalanceOutput.vue?vue&type=style&index=0&id=dccd434c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccd434c",
  null
  
)

export default component.exports